// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"b98a211c","395":"4864cac1","586":"2f61f6a4","592":"326951cd","787":"32bf64e7"}[chunkId] + ".chunk.js";
};